// eslint-disable-next-line no-unused-vars
import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { TextInput } from '@carbon/react';

const StyledTextInput = styled.div`
  flex: 1 1 auto;

  .cds--text-input:disabled {
    border-bottom: 1px solid #E2E2E2;
    background-color: #f4f4f4;
  }

  .cds--text-input-wrapper {
    position: relative;
    margin-bottom: 25px;

    .cds--form-requirement {
      position: absolute;
      top: 100%;;
    }
  }

  .cds--text-input-wrapper--readonly .cds--text-input {
    border-bottom: 1px solid #E2E2E2;
    background-color: #f4f4f4;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  input[type=number] {
    -moz-appearance: textfield;
  }

  label {
    ${ props => props.isRequired && `
      &:after {
        content: '*';
        display: inline-block;
        margin-left: 5px;
        color: ${ props.theme.colors.default };
      }
    ` }
    margin-bottom: 5px;
    font-size: 0.875rem;
    line-height: 1rem;
    color: ${ props => props.theme.colors.darkGray };

    input {
      font-size: 0.875rem;
      color: ${ props => props.theme.colors.gray };
    }
  }

  input {
    border: 1px solid ${ props => props.theme.products.colors.border };
    border-radius: 5px;
    background-color: #fff;
    margin-top: 0;
  }

  margin: 10px 0 15px;
`;

const NWTextInput = forwardRef(({ className, required, id, submitOnEnter, ...rest }, ref) => {
  const theme = useTheme();
  const textInputProps = {
    required,
    id,
    ...rest,
    ref
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      if (submitOnEnter) {
        submitOnEnter();
      }
    }
  };

  return (
    <StyledTextInput theme={ theme } className={ className } isRequired={ required }>
      <TextInput
        className="NW-TextInputWrapper"
        data-test={ id }
        onKeyDown={ handleKeyDown }
        { ...textInputProps }
      />
    </StyledTextInput>
  );
});

NWTextInput.propTypes = TextInput.propTypes;

export { NWTextInput };
